import React from 'react'
import Icon from './icons'

// Ported from the source project's src/components/site/Services.tsx. Per-card Reveal
// dropped because the task brief's index.jsx wraps the whole
// <Services/> section in one Reveal, not each card.
const Services = ({ section, services }) => {
    return (
        <section className="section services-section" id="services">
            <div className="container">
                <div className="services-header">
                    <div>
                        <div className="section-eyebrow">{section.eyebrow}</div>
                        <h2 className="section-title">{section.title}</h2>
                    </div>
                    {section.subtitle && <p className="section-sub">{section.subtitle}</p>}
                </div>
                <div className="services-grid">
                    {services.map((svc) => (
                        <div className="service-card" key={svc.order}>
                            <div className="service-icon">
                                <Icon name={svc.icon} />
                            </div>
                            <div className="service-name">{svc.name}</div>
                            <p className="service-desc">{svc.description}</p>
                            <div className="service-tags">
                                {svc.tags.map((t) => (
                                    <span className="tag" key={t}>{t}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
